import React, { useEffect, useState } from "react";
import {
  AiOutlineEye,
  AiOutlineEdit,
  AiOutlineDelete,
  AiOutlineClose,
} from "react-icons/ai";
import Swal from "sweetalert2";
import "./DisplayPrograms.scss";
import axios from "axios";
import apiService from "../../../../../global/common/environment";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

const DisplayPrograms = () => {
  const [courses, setCourses] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const nav = useNavigate();

  useEffect(() => {
    getAllPrograms();
  }, []);

  const getAllPrograms = async () => {
    try {
      const res = await axios.get(apiService.getProgramCourse + "/admin");
      setCourses(res.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const filteredCourses = courses.filter(
    (course) =>
      course.courseName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      course.collageName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredCourses.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredCourses.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleView = (course) => {
    console.log(course); // Handle view
  };

  const handleEdit = (id) => {
    nav("/admin/programs/" + id);
  };

  const handleDelete = async (courseId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(apiService.deleteProgramCourse(courseId));
        getAllPrograms();
        toast.success("Course deleted successfully");
      } catch (err) {
        console.log(err);
        toast.error("Failed to delete course");
      }
    }
  };

  return (
    <>
      <div className="programs-header">
        <h1>Program Courses</h1>
        <input
          type="text"
          placeholder="Search by Course Name or College Name"
          value={searchTerm}
          onChange={handleSearch}
          style={{
            width: "400px",
            padding: "10px 15px",
            borderRadius: "10px",
            marginTop: "10px",
            fontSize: "16px",
            transition: "border-color 0.3s ease, box-shadow 0.3s ease",
            outline: "none",
            paddingLeft: "40px",
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M13.708 12.292a7.5 7.5 0 1 0-1.416 1.416l3.707 3.707a1 1 0 1 0 1.415-1.414l-3.707-3.707zM9 14.5a5.5 5.5 0 1 1 5.5-5.5 5.506 5.506 0 0 1-5.5 5.5z' fill='%23999' /%3E%3C/svg%3E\")",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "10px center",
            backgroundSize: "16px",
          }}
        />
        <button
          className="add-program-btn"
          onClick={() => nav("/admin/programs/")}
        >
          Add Program
        </button>
      </div>

      <div className="course-table">
        <table>
          <thead>
            <tr>
              <th>SNo</th>
              <th>Course Name</th>
              <th>College Name</th>
              <th>Description</th>
              <th>Duration</th>
              <th>Tuition Fee</th>
              <th>View</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((course, i) => (
              <tr key={i}>
                <td>{indexOfFirstItem + i + 1}</td>
                <td>{course.courseName}</td>
                <td>{course.collageName}</td>
                <td>{course.courseDescription}</td>
                <td>{course.courseLength}</td>
                <td>{course.annualTuitionFee}</td>
                <td>
                  <span
                    className={
                      course.published === "Y"
                        ? "btn btn-success"
                        : "btn btn-danger"
                    }
                  >
                    {course.published === "Y" ? "Published" : "Unpublished"}
                  </span>
                </td>
                <td>
                  <div style={{ display: "flex", gap: "5px" }}>
                    <button onClick={() => handleView(course)}>
                      <AiOutlineEye />
                    </button>
                    <button onClick={() => handleEdit(course._id)}>
                      <AiOutlineEdit />
                    </button>
                    <button onClick={() => handleDelete(course._id)}>
                      <AiOutlineDelete />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <br />
      <div className="d-flex justify-content-center">
      <Button
  variant="secondary"
  onClick={() => paginate(currentPage - 1)}
  disabled={currentPage === 1}
  style={{
    backgroundColor: "#ffffff",
    border: "2px solid #007bff",
    color: "#007bff",
    borderRadius: "5px",
    padding: "8px 16px",
    fontWeight: "bold",
    cursor: currentPage === 1 ? "not-allowed" : "pointer",
    opacity: currentPage === 1 ? 0.5 : 1,
    margin: "0 5px",
  }}
>
  Previous
</Button>

{Array.from({ length: totalPages }).map(
  (_, index) =>
    index >= currentPage - 2 && index <= currentPage && (
      <Button
        key={index}
        variant={currentPage === index + 1 ? "primary" : "light"}
        onClick={() => paginate(index + 1)}
        style={{
          backgroundColor: currentPage === index + 1 ? "#007bff" : "#ffffff",
          color: currentPage === index + 1 ? "white" : "#007bff",
          border: `2px solid ${currentPage === index + 1 ? "#007bff" : "#007bff"}`,
          borderRadius: "5px",
          padding: "8px 16px",
          fontWeight: "bold",
          cursor: "pointer",
          margin: "0 5px",
          
        }}
      >
        {index + 1}
      </Button>
    )
)}

<Button
  variant="secondary"
  onClick={() => paginate(currentPage + 1)}
  disabled={currentPage === totalPages}
  style={{
    backgroundColor: "#ffffff",
    border: "2px solid #007bff",
    color: "#007bff",
    borderRadius: "5px",
    padding: "8px 16px",
    fontWeight: "bold",
    cursor: currentPage === totalPages ? "not-allowed" : "pointer",
    opacity: currentPage === totalPages ? 0.5 : 1,
    margin: "0 5px",
  }}
>
  Next
</Button>

        <br />
      </div>
    </>
  );
};

export default DisplayPrograms;
